import { useContext } from 'react'

import PortalConfigContext from 'context/PortalConfigContext'

import { getConfig } from '../EnvConfig'

export const FEATURE_FLAGS = {
  approvalState: 'approvalState',
  portalsAddressesPaymentsTimeSlices: 'portalsAddressesPaymentsTimeSlices',
  portalAnalytics: 'portalAnalytics',
  dynamicTariff: 'dynamicTariff',
  templateVariables: 'templateVariables',
  entitySelection: 'entitySelection',
  realTimeEntityUpdates: 'realTimeEntityUpdates',
  portalsConfirmLeaveJourney: 'portals-confirm-leave-journey'
}

export type FeatureFlag = keyof typeof FEATURE_FLAGS

export type FeatureToggleValues =
  (typeof FEATURE_TOGGLE)[keyof typeof FEATURE_TOGGLE]

export const FEATURE_TOGGLE = {
  Contracts: 'contracts_preview_setting',
  Meters: 'metering_settings',
  Dashboard: 'ecp_dashboard',
  Billing: 'commodity_billing'
}

export enum PortalFeature {
  START_PAGE = 'start_page',
  BILLING = 'commodity_billing',
  CHANGE_DUE_DATE = 'change_due_date',
  NEW_DESIGN = 'new_design',
  PORTAL_COPILOT = 'portal_copilot'
}

export const isFeatureFlagEnabled = (
  flagName: FeatureFlag,
  flags?: Record<string, boolean>
): boolean => {
  if (!flags) return false

  return Boolean(flags[FEATURE_FLAGS[flagName]])
}

export const useFeatureFlags = () => {
  const { data } = useContext(PortalConfigContext)

  return data?.portalConfig?.feature_flags
}

export const useIsFeatureFlagEnabled = (
  flagName: keyof typeof FEATURE_FLAGS
) => {
  const { data } = useContext(PortalConfigContext)
  const flags = data?.portalConfig?.feature_flags

  return isFeatureFlagEnabled(flagName, flags)
}

export const useIsFeatureSettingsEnabled = (
  featureName: keyof typeof PortalFeature
): boolean => {
  const { data: configData } = useContext(PortalConfigContext)
  const featureSettings = configData.portalConfig?.feature_settings || {}

  const featureConfigKey = `FEATURE_SETTING_OVERRIDE_${featureName}`
  const envConfig = getConfig()

  if (featureConfigKey in envConfig) {
    return envConfig[featureConfigKey]
  }

  return Boolean(featureSettings[PortalFeature[featureName]])
}
